"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FullPriceModalMobile = void 0;
var _uiKit = require("@cian/ui-kit");
var _icons = require("@cian/ui-kit-design-tokens/icons");
var React = _interopRequireWildcard(require("react"));
var styles = _interopRequireWildcard(require("./FullPriceModalMobile.css"));
var _LinkedPromo = require("../PurchaseTermsModal/parts/LinkedPromo");
var _Controls = require("../PromoModal/parts/Controls");
var _trackAdditionalPromoClick = require("../PromoModal/tracking/trackAdditionalPromoClick");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const FullPriceModalMobile = _ref => {
  let {
    open,
    onClose,
    description,
    controls,
    linkedPromosTitle,
    linkedPromosSubtitle,
    linkedPromos
  } = _ref;
  const [collapsedId, setCollapsedId] = React.useState(null);
  const handlePromoClick = (id, type) => {
    const isSameId = collapsedId === id;
    setCollapsedId(isSameId ? null : id);
    if (!isSameId) {
      (0, _trackAdditionalPromoClick.trackAdditionalPromoClick)({
        type,
        id
      });
    }
  };
  return /*#__PURE__*/React.createElement(_uiKit.PromoModalRoot, {
    onOpenChange: onClose,
    open: open,
    modal: true
  }, /*#__PURE__*/React.createElement(_uiKit.PromoModalContent, {
    "data-testid": "FullPriceModal"
  }, /*#__PURE__*/React.createElement(_uiKit.PromoModalCloseButton, {
    theme: "fill_light",
    size: "XS",
    icon: /*#__PURE__*/React.createElement(_icons.IconActionClose16, {
      color: "current_color"
    }),
    title: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C"
  }), /*#__PURE__*/React.createElement(_uiKit.PromoModalMedia, null, /*#__PURE__*/React.createElement("div", {
    className: styles['media']
  })), /*#__PURE__*/React.createElement(_uiKit.PromoModalBody, null, /*#__PURE__*/React.createElement(_uiKit.PromoModalTitle, null, "100% \u043E\u043F\u043B\u0430\u0442\u0430"), /*#__PURE__*/React.createElement(_uiKit.PromoModalDescription, {
    whiteSpace: "pre-wrap"
  }, description), linkedPromos && linkedPromos.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: styles['linked-promos']
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_uiKit.UIHeading4, null, linkedPromosTitle), /*#__PURE__*/React.createElement(_uiKit.UIText2, {
    color: "text-secondary-default"
  }, linkedPromosSubtitle)), /*#__PURE__*/React.createElement("div", null, linkedPromos.map(promo => /*#__PURE__*/React.createElement(_LinkedPromo.LinkedPromo, {
    key: promo.id,
    name: promo.name,
    activeDateTo: promo.activeDateTo,
    description: promo.description,
    onClick: () => handlePromoClick(promo.id, promo.type),
    collapsed: collapsedId !== promo.id
  }))))), /*#__PURE__*/React.createElement(_uiKit.PromoModalFooter, null, /*#__PURE__*/React.createElement(_Controls.Controls, null, controls))));
};
exports.FullPriceModalMobile = FullPriceModalMobile;